// material
import { Chip } from '@mui/material';

export default function generate({ t, theme }) {
  return [
    {
      name: 'controlDate',
      label: t('dashboard.recent-controls.date'),
      options: {
        sort: false,
      }
    },
    {
      name: 'resource.name',
      label: t('dashboard.recent-controls.resource'),
      options: {
        sort: false,
        customBodyRender: (value) => value || t('common.unknown')
      }
    },
    {
      name: 'flow.name',
      label: t('dashboard.recent-controls.flow'),
      options: {
        sort: false,
        customBodyRender: (value) => value || t('common.unknown')
      }
    },
    {
      name: 'conformity',
      label: t('dashboard.recent-controls.conformity'),
      options: {
        sort: false,
        customBodyRender: (value) => {
          if (!value) return '-';
          const isOk = value.id === 1;
          const isScheduled = value.id === 2;
          let bgColor = theme.palette.error.main;
          let textColor = theme.palette.error.contrastText;
          if (isOk) {
            bgColor = theme.palette.success.main;
            textColor = theme.palette.success.contrastText;
          } else if (isScheduled) {
            bgColor = theme.palette.info.main;
            textColor = theme.palette.info.contrastText;
          }
          return (
            <Chip
              label={value.title}
              size="small"
              sx={{
                backgroundColor: bgColor,
                color: textColor,
                fontWeight: 500,
              }}
            />
          );
        }
      }
    },
    {
      name: 'reportState',
      label: t('dashboard.recent-controls.report-state'),
      options: {
        sort: false,
        customBodyRender: (value) => {
          const isAvailable = value === 1;
          return (
            <Chip
              label={
                value === 0
                  ? t('dashboard.recent-controls.generating')
                  : t('dashboard.recent-controls.available')
              }
              size="small"
              variant="outlined"
              sx={{
                borderColor: isAvailable ? theme.palette.grey[400] : theme.palette.warning.main,
                color: isAvailable ? theme.palette.text.primary : theme.palette.warning.main,
              }}
            />
          );
        }
      }
    }
  ];
}
